import { EDIT_TAGS_REQUEST_ASYNC, TAGS_REQUEST_ASYNC } from './constants'

// IC-47782: tags are scoped per incident so overlapping fetches (e.g. the classification modal
// for incident A while the report body auto-advances to incident B) can't clobber each other.
const keyOf = (reportType, reportId) => `${reportType}:${reportId}`
const EMPTY_ENTRY = { data: { allTags: [], selectedTags: [] }, loader: false, error: null }

export default function () {
  const initialState = { byReport: {} }

  const patch = (state, reportType, reportId, changes) => {
    const key = keyOf(reportType, reportId)
    return {
      ...state,
      byReport: {
        ...state.byReport,
        [key]: { ...(state.byReport[key] || EMPTY_ENTRY), ...changes },
      },
    }
  }

  return (state = initialState, action) => {
    const { reportId, reportType } = action.payload || {}

    switch (action.type) {
      case TAGS_REQUEST_ASYNC.INITIATE:
        return patch(state, reportType, reportId, { loader: true, error: null })
      case TAGS_REQUEST_ASYNC.SUCCESS:
        return patch(state, reportType, reportId, {
          data: action.payload.data,
          loader: false,
          error: null,
        })
      case TAGS_REQUEST_ASYNC.ERROR:
        return patch(state, reportType, reportId, { loader: false, error: action.error })
      case EDIT_TAGS_REQUEST_ASYNC.INITIATE:
        return patch(state, reportType, reportId, { loader: true })
      case EDIT_TAGS_REQUEST_ASYNC.SUCCESS: {
        const selectedTags = action.payload.data
        const currentData = (state.byReport[keyOf(reportType, reportId)] || EMPTY_ENTRY).data
        const currentAllTags = currentData.allTags || []
        const newTags = selectedTags.filter((tag) => !currentAllTags.includes(tag))
        return patch(state, reportType, reportId, {
          loader: false,
          error: null,
          data: { selectedTags, allTags: [...currentAllTags, ...newTags] },
        })
      }
      case EDIT_TAGS_REQUEST_ASYNC.ERROR:
        return patch(state, reportType, reportId, { loader: false, error: action.error })
      default:
        return state
    }
  }
}
